import client from "api/client";

const PATHS = {
  GET_LEVELS: "/levels?populate[parts][populate]=*&sort=index:ASC",
};

export const getLevels = async () => {
  return await client.get(PATHS.GET_LEVELS);
};

export const levelsQuery = {
  queryKey: ["levels"],
  queryFn: getLevels,
  select: ({ data }) => data.data || [],
};
